import Core from '_abstracts/core'

/**
 *  Marfeel config
 */

Core.Tasks.add(['user', 'page'], () => {
    try {

        var userStatus = 0

        if (Core.User.get('isLogged')) {
            if(Core.User.get('isSubscriber')) {
                userStatus = 3
            } else {
                userStatus = 2
            }
        } 

        window.marfeel.cmd.push(['compass', function(compass) {
            compass.setUserType(userStatus);
        }]);

    } catch (ex) {
        console.error(ex)
    }
})